import gql from 'graphql-tag';

import {
  printProductSizeRoesGraphicNodeDetails,
  printProductSizeServiceDetails,
} from '../../../../graphql/fragments/print-product';

const printProductDetails = gql`
  fragment printProductDetails on PrintProduct {
    id
    name
    is_standard
    card {
      id
    }
    print_partner {
      id
      name
    }
    sizes(slice: { limit: 99 }) {
      total
      records {
        id
        print_size {
          id
          name
          width
          height
        }
        price {
          value
          currency
        }
        min_price {
          value
          currency
        }
        total_price {
          value
          currency
        }
        mounts {
          total
        }
        orientations
        services {
          total
          records {
            ...printProductSizeServiceDetails
          }
        }
        roes_info {
          layout_file
          graphic_nodes(slice: { limit: 99 }) {
            total
            records {
              ...printProductSizeRoesGraphicNodeDetails
            }
          }
        }
      }
    }
    print_size {
      id
      name
      width
      height
    }

    preview_asset_image {
      id
      url
    }
  }
  ${printProductSizeServiceDetails}
  ${printProductSizeRoesGraphicNodeDetails}
`;

export default printProductDetails;
